import styled from "styled-components";

const getVariantStyles = (variant?: string) => {
  switch (variant) {
    case 'primary':
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        shadow: 'rgba(102, 126, 234, 0.3)',
        hoverShadow: 'rgba(102, 126, 234, 0.4)',
        focusShadow: 'rgba(102, 126, 234, 0.3)'
      };
    case 'secondary':
      return {
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        shadow: 'rgba(240, 147, 251, 0.3)',
        hoverShadow: 'rgba(240, 147, 251, 0.4)',
        focusShadow: 'rgba(240, 147, 251, 0.3)'
      };
    case 'success':
      return {
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        shadow: 'rgba(79, 172, 254, 0.3)',
        hoverShadow: 'rgba(79, 172, 254, 0.4)',
        focusShadow: 'rgba(79, 172, 254, 0.3)'
      };
    case 'warning':
      return {
        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        shadow: 'rgba(250, 112, 154, 0.3)',
        hoverShadow: 'rgba(250, 112, 154, 0.4)',
        focusShadow: 'rgba(250, 112, 154, 0.3)'
      };
    case 'danger':
      return {
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
        shadow: 'rgba(255, 107, 107, 0.3)',
        hoverShadow: 'rgba(255, 107, 107, 0.4)',
        focusShadow: 'rgba(255, 107, 107, 0.3)'
      };
    default:
      return {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        shadow: 'rgba(102, 126, 234, 0.3)',
        hoverShadow: 'rgba(102, 126, 234, 0.4)',
        focusShadow: 'rgba(102, 126, 234, 0.3)'
      };
  }
};

export const StyledButton = styled("button")<{ color?: string; variant?: string }>`
  background: ${(p) => {
    if (p.color === "#000") {
      return "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
    }
    if (p.color) {
      return p.color;
    }
    const variantStyles = getVariantStyles(p.variant);
    return variantStyles.background;
  }};
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  width: 100%;
  border: none;
  border-radius: 12px;
  padding: 14px 24px;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 200px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: ${(p) => {
    const variantStyles = getVariantStyles(p.variant);
    return `0 8px 25px ${variantStyles.shadow}`;
  }};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(p) => {
      const variantStyles = getVariantStyles(p.variant);
      return `0 12px 35px ${variantStyles.hoverShadow}`;
    }};
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: ${(p) => {
      const variantStyles = getVariantStyles(p.variant);
      return `0 6px 20px ${variantStyles.shadow}`;
    }};
  }

  &:focus {
    outline: none;
    box-shadow: ${(p) => {
      const variantStyles = getVariantStyles(p.variant);
      return `0 0 0 3px ${variantStyles.focusShadow}`;
    }};
  }
`;
